
<div v-if="showBar" class="navigation-progress" role="status" :aria-label="$t('general.loading')">
  <div class="track">
    <div class="bar" />
  </div>
  <transition name="fade-hint">
    <span v-if="isSlowNavigation" class="hint">{{ $t('general.takingLongerThanUsual') }}</span>
  </transition>
</div>
